export default {
  label: {
    xAxis: {
      title: 'Horário',
    },
    yAxis: {
      title: 'Respondentes',
    },
    bubble: {
      name: 'Nome',
      value: 'Total de atividade',
      hour: 'Horário',
      opened: 'Aberto',
      answered: 'Respondido',
      waiting: 'Em Espera',
      closed: 'Fechado',
      ignored: 'Ignorado',
      percentage: 'Porcentagem p/ usuário',
      percentageGlobal: 'Porcentagem Global',
    },
  },
};
